<template>
  <UiComponentWrapper class="get-a-demo">
    <UiComponentContainer class="room">
      <UiComponentWrapper class="header">
        <UiComponentWrapper class="event">
          <UiComponentImage
            class="logo"
            alt="Livestorm logo"
            :height="336"
            :expected-size="32"
            source="https://livestorm.imgix.net/1127/1623336879-type-storm-theme-light-padding-false-generation-new.png"
            :width="336"
          />
          <UiComponentWrapper class="info">
            <UiComponentParagraph>Livestorm Demo</UiComponentParagraph>
            <UiComponentParagraph>Tuesday, October 26th - 3:00 PM</UiComponentParagraph>
          </UiComponentWrapper>
        </UiComponentWrapper>
        <UiComponentWrapper class="action">
          <UiComponentParagraph class="started-at">
            Started <span>5m</span> ago
          </UiComponentParagraph>
          <AtomButton>End event</AtomButton>
        </UiComponentWrapper>
      </UiComponentWrapper>
      <UiComponentWrapper class="main">
        <UiComponentWrapper class="streams">
          <UiComponentWrapper class="stream">
            <UiComponentImage
              alt="Stream 1"
              :height="1722"
              :expected-size="574"
              orientation="portrait"
              source="https://livestorm.imgix.net/1127/1672932135-stream1.jpg"
              :width="1698"
            />
            <UiComponentWrapper class="user">
              <UiComponentImage
                class="avatar"
                alt="Avatar"
                :height="72"
                :expected-size="24"
                source="https://livestorm.imgix.net/1127/1672932127-avatar1.jpg"
                :width="72"
              />
              <UiComponentParagraph>Daniel Smith</UiComponentParagraph>
            </UiComponentWrapper>
          </UiComponentWrapper>
          <UiComponentWrapper class="stream">
            <UiComponentImage
              alt="Stream 2"
              :height="1722"
              :expected-size="574"
              orientation="portrait"
              source="https://livestorm.imgix.net/1127/1672932139-stream2.jpg"
              :width="1698"
            />
            <UiComponentWrapper class="user">
              <UiComponentImage
                class="avatar"
                alt="Avatar"
                :height="72"
                :expected-size="24"
                source="https://livestorm.imgix.net/1127/1672932130-avatar2.jpg"
                :width="72"
              />
              <UiComponentParagraph>William Johnson</UiComponentParagraph>
            </UiComponentWrapper>
          </UiComponentWrapper>
        </UiComponentWrapper>
        <UiComponentWrapper class="sidebar">
          <UiComponentImage
            alt="Sidebar"
            :height="1722"
            :expected-size="279"
            orientation="portrait"
            source="https://livestorm.imgix.net/1127/1672932132-sidebar.jpg"
            :width="837"
          />
        </UiComponentWrapper>
      </UiComponentWrapper>
      <UiComponentWrapper class="footer">
        <UiComponentWrapper class="help">
          <UiComponentIcon type="help-circle" />
          <UiComponentParagraph>Help</UiComponentParagraph>
        </UiComponentWrapper>
        <UiComponentWrapper class="actions">
          <UiComponentWrapper class="item">
            <UiComponentImage
              alt="Micro"
              :height="16"
              :expected-size="12.7"
              source="https://livestorm.imgix.net/1127/1672929586-mic.svg"
              :width="16"
            />
            <UiComponentParagraph>Micro</UiComponentParagraph>
          </UiComponentWrapper>
          <UiComponentWrapper class="item">
            <UiComponentImage
              alt="Camera"
              :height="16"
              :expected-size="12.7"
              source="https://livestorm.imgix.net/1127/1672929584-camera.svg"
              :width="16"
            />
            <UiComponentParagraph>Camera</UiComponentParagraph>
          </UiComponentWrapper>
          <UiComponentWrapper class="item">
            <UiComponentImage
              alt="Share"
              :height="16"
              :expected-size="12.7"
              source="https://livestorm.imgix.net/1127/1672929589-screensharing.svg"
              :width="16"
            />
            <UiComponentParagraph>Share</UiComponentParagraph>
          </UiComponentWrapper>
          <UiComponentWrapper class="item">
            <UiComponentImage
              alt="Record"
              :height="16"
              :expected-size="12.7"
              source="https://livestorm.imgix.net/1127/1672929588-record.svg"
              :width="16"
            />
            <UiComponentParagraph>Record</UiComponentParagraph>
          </UiComponentWrapper>
          <UiComponentWrapper class="item">
            <UiComponentImage
              alt="React"
              :height="16"
              :expected-size="12.7"
              source="https://livestorm.imgix.net/1127/1672929587-reactions.svg"
              :width="16"
            />
            <UiComponentParagraph>React</UiComponentParagraph>
          </UiComponentWrapper>
          <UiComponentWrapper class="item">
            <UiComponentImage
              alt="Layout"
              :height="16"
              :expected-size="12.7"
              source="https://livestorm.imgix.net/1127/1672929589-screensharing.svg"
              :width="16"
            />
            <UiComponentParagraph>Layout</UiComponentParagraph>
          </UiComponentWrapper>
        </UiComponentWrapper>
        <UiComponentWrapper class="sidebar">
          <UiComponentWrapper class="item">
            <UiComponentImage
              alt="Apps"
              :height="16"
              :expected-size="12.7"
              source="https://livestorm.imgix.net/1127/1672934003-apps.svg"
              :width="16"
            />
            <UiComponentParagraph>Apps</UiComponentParagraph>
          </UiComponentWrapper>
          <UiComponentWrapper class="item">
            <UiComponentParagraph>10</UiComponentParagraph>
            <UiComponentParagraph>People</UiComponentParagraph>
          </UiComponentWrapper>
          <UiComponentWrapper class="item">
            <UiComponentImage
              alt="Polls"
              :height="16"
              :expected-size="12.7"
              source="https://livestorm.imgix.net/1127/1672934005-polls.svg"
              :width="16"
            />
            <UiComponentParagraph>Polls</UiComponentParagraph>
          </UiComponentWrapper>
          <UiComponentWrapper class="item">
            <UiComponentImage
              alt="Questions"
              :height="16"
              :expected-size="12.7"
              source="https://livestorm.imgix.net/1127/1672934007-questions.svg"
              :width="16"
            />
            <UiComponentParagraph>Questions</UiComponentParagraph>
          </UiComponentWrapper>
          <UiComponentWrapper class="item">
            <UiComponentImage
              alt="Chat"
              :height="16"
              :expected-size="12.7"
              source="https://livestorm.imgix.net/1127/1672934004-chat.svg"
              :width="16"
            />
            <UiComponentParagraph>Chat</UiComponentParagraph>
          </UiComponentWrapper>
        </UiComponentWrapper>
      </UiComponentWrapper>
    </UiComponentContainer>
    <UiComponentWrapper class="overlay">
      <UiComponentContainer class="inner">
        <UiComponentHeading :level="2">
          {{ content.title }}
        </UiComponentHeading>
        <UiComponentParagraph>{{ content.text }}</UiComponentParagraph>
        <UiComponentWrapper
          v-if="hasCustomCallToAction"
          class="actions"
        >
          <AtomButton
            :action="callToAction.action"
            label="Big section CTA"
            size="l"
            :to="callToAction.to"
            type="secondary"
            @click="callToAction.onClick"
          >
            {{ callToAction.slot }}
          </AtomButton>
        </UiComponentWrapper>
        <UiComponentWrapper
          v-else
          class="actions"
        >
          <AtomButton
            :action="requestDemoCallToAction.action"
            label="Big section CTA"
            size="l"
            :to="requestDemoCallToAction.to"
            type="secondary"
          >
            {{ requestDemoCallToAction.slot }}
          </AtomButton>
          <UiComponentParagraph>{{ content.wordingForOr }}</UiComponentParagraph>
          <AtomButton
            :action="onDemandDemoCallToAction.action"
            label="Big section CTA"
            :to="onDemandDemoCallToAction.to"
            type="text"
          >
            {{ onDemandDemoCallToAction.slot }}
          </AtomButton>
        </UiComponentWrapper>
      </UiComponentContainer>
    </UiComponentWrapper>
  </UiComponentWrapper>
</template>

<script setup>
// Props
const props = defineProps({
  callToAction: {
    default() {
      return undefined
    },
    required: false,
    type: Object,
  },
  content: {
    required: true,
    type: Object,
  },
  global: {
    required: true,
    type: Object,
  },
})

// Computed Properties
const hasCustomCallToAction = computed(() => {
  return !!props.callToAction
})

const onDemandDemoCallToAction = computed(() => {
  return {
    action: 'On-demand demo clicked',
    slot: props.global.ctaOnDemandDemoLong,
    to: props.content.link,
  }
})

const requestDemoCallToAction = computed(() => {
  return {
    action: 'Demo clicked',
    slot: props.global.ctaGetDemo,
    to: '#form-demo',
  }
})
</script>

<style lang="postcss" scoped>
.get-a-demo {
  @apply relative justify-center bg-winter-green-900;

  &:hover {
    @screen lg {
      .room {
        .header {
          @apply opacity-100 translate-y-0;
        }

        .main {
          @apply opacity-10;
        }

        .footer {
          @apply opacity-100 translate-y-0;
        }
      }
    }
  }

  .room {
    @apply flex-col p-2 z-0 overflow-hidden;

    .header {
      @apply justify-between p-1 opacity-30 transform transition-all duration-800 ease-in-out;

      @screen lg {
        @apply opacity-0 -translate-y-full;
      }

      .event {
        @apply w-auto;

        .logo {
          @apply flex-shrink-0 rounded-none;
        }

        .info {
          @apply flex-col ml-2;

          p {
            @apply flex-shrink-0 font-inter font-semibold text-white text-xs leading-[14px];
          }

          p + p {
            @apply mt-1 font-normal text-white/70;
          }
        }
      }

      .action {
        @apply flex-row items-center w-auto bg-transparent rounded-none !important;

        .started-at {
          @apply hidden;

          @screen md {
            @apply inline font-inter font-semibold text-xs text-white/50;
          }

          span {
            @apply text-white;
          }
        }

        .button {
          @apply flex-shrink-0 h-auto px-[9px] py-2 bg-[#E54538]/50 font-inter font-semibold text-xs rounded-xs;

          @screen md {
            @apply ml-[11px];
          }
        }
      }
    }

    .main {
      @apply flex-row h-[481px] p-1 opacity-5 transition-opacity duration-800 ease-in-out;

      @screen lg {
        @apply opacity-0;
      }

      @screen xl {
        @apply h-[574px];
      }

      .streams {
        @apply flex-col rounded-xs overflow-hidden;

        @screen md {
          @apply flex-row;
          width: calc(100% - 286.5px);
        }

        .stream {
          @apply relative items-center justify-center w-full my-[0.75px] overflow-hidden;
          height: calc((100% - 1.5px) / 2);

          @screen md {
            @apply h-full mx-[0.75px] my-0;
            width: calc((100% - 1.5px) / 2);
          }

          &:first-child {
            @apply mt-0;

            @screen md {
              @apply ml-0;
            }
          }

          &:last-child {
            @apply mb-0;

            @screen md {
              @apply mr-0;
            }
          }

          picture {
            @apply rounded-none;

            :deep(img) {
              @apply object-contain;

              @screen md {
                @apply object-cover;
              }
            }
          }

          .user {
            @apply absolute bottom-3 left-3 items-center;

            .avatar {
              @apply rounded-full;
            }

            p {
              @apply ml-2 font-inter font-semibold text-white text-[13px] leading-6;
            }
          }
        }
      }

      .sidebar {
        @apply hidden;

        @screen md {
          @apply flex flex-shrink-0 w-[279px] ml-[7.5px] rounded-xs overflow-hidden;
        }

        picture {
          @apply rounded-none;
        }
      }
    }

    .footer {
      @apply relative justify-center px-1 pt-1 opacity-30 transform transition-all duration-800 ease-in-out;

      @screen lg {
        @apply opacity-0 translate-y-full;
      }

      .help {
        @apply absolute left-0 hidden;

        @screen xl {
          @apply flex flex-col items-center justify-center h-12 w-8;
        }

        i {
          @apply font-bold text-[13.5px] text-white/70 leading-none;
        }

        p {
          @apply mt-[3.3px] font-inter font-semibold text-white/70 text-[10px] leading-[14px];
        }
      }

      .actions {
        @apply w-auto bg-white/10 border border-white/5 rounded-[9.5px];

        .item {
          @apply flex-col items-center justify-center h-12 w-[57.2px];

          picture {
            @apply rounded-none;
          }

          p {
            @apply mt-2 font-inter font-semibold text-white/80 text-[10px] leading-none;
          }
        }
      }

      .sidebar {
        @apply absolute right-0 hidden;

        @screen xl {
          @apply flex w-auto;
        }

        .item {
          @apply flex-col items-center justify-center h-12 w-[57.2px];

          picture {
            @apply rounded-none;
          }

          p {
            @apply font-semibold text-white text-[11px] leading-[12.7px];
          }

          * + p {
            @apply mt-2 font-inter font-semibold text-white/80 text-[10px] leading-none;
          }
        }
      }
    }
  }

  .overlay {
    @apply absolute inset-0 items-center justify-center;

    .inner {
      @apply flex-col items-center max-w-[792px];

      .h2 {
        @apply text-center text-white;
      }

      .h2 + p {
        @apply mt-4 text-center text-livestorm-blue-200 leading-7;
      }

      .actions {
        @apply flex-col items-center mt-8;

        p {
          @apply my-4 text-center text-white leading-7;
        }

        .button {
          @apply self-center;

          &.text {
            @apply h-auto px-0 font-bold text-white text-origin leading-none;
          }
        }
      }
    }
  }
}
</style>
